
  export default {
    props: { article: { type: Object, required: true } },
    data () {
      return {
        categories: {
          'banking': '/money/',
          'broadband': '/compare-tv-broadband-phone/',
          'broadband-phone': '/compare-tv-broadband-phone/',
          'broadband-tv': '/compare-tv-broadband-phone/',
          'broadband-phone-tv': '/compare-tv-broadband-phone/',
          'gas-electricity': '/compare-gas-electricity-prices/',
          'insurance': '/compare-insurance/',
          'health-insurance': '/compare-health-insurance/',
          'mortgage': '/compare-mortgages/',
          'personal-finance': '/money/'
        },
        timeToRead: null
      };
    }
  };
